import EnterpriseService from 'services/Enterprises.service';
import { observable, action } from 'mobx';

class EnterprisesStore {
  enterprises = observable([]);
  initialFetchDone = observable.box(false);

  @action
  async getEnterprises() {
    if (this.initialFetchDone.get()) {
      return this.enterprises;
    }

    try {
      const items = await EnterpriseService.fetchEnterprises();
      if (items.isEmpty) {
        return null;
      }

      this.enterprises.push(...items.items);
    } catch (e) {
      console.error('Failed to fetch enterprises data');
      return null;
    }

    this.initialFetchDone.set(true);
    return this.enterprises;
  }

  getEnterprisesByType(type) {
    if (!type) {
      return this.enterprises;
    }

    const filter = Array.isArray(type) ? type : [type];

    return this.enterprises.filter(enterprise =>
      enterprise.enterpriseTypes.find(e => filter.includes(e))
    );
  }
}

export default new EnterprisesStore();



// WEBPACK FOOTER //
// ./src/stores/Enterprises.store.js